import { faAngleLeft, faTimes } from '@fortawesome/pro-light-svg-icons'
import React, { forwardRef } from 'react'

import { Button } from '../../layout_components/Button'
import { locale } from '../../locales/locale'
import { useAppSelector } from '../../redux/hooks'
import { HeaderDetailedProps } from './definitions'
import FBCommunityBanner from './FBCommunityBanner'
import { HeaderDetailedContainer, IconClose } from './header.components'

const HelpHeaderDetailed = forwardRef<HTMLDivElement, HeaderDetailedProps>(
  (props, ref) => {
    const realm = useAppSelector((state) => state.realm.value)
    const isEditorMode = useAppSelector((state) => state.editor.value)
    if (isEditorMode) return <></>
    return (
      <HeaderDetailedContainer ref={ref}>
        <>
          {realm === 'fic' && !props.isExternal && (
            <FBCommunityBanner />
          )}
          <div
            className={`sectionHeader ${
              props.embedded ? 'embeddedHeader' : ''
            }`}
          >
            {!props.isExternal && (
              <Button
                type={'text'}
                iconLeft={faAngleLeft}
                text={locale('Indietro')}
                onClick={props.onClick}
                customClass={'goback'}
              />
            )}
            <h1>{props.title}</h1>
            {props.description && (
              <h4 className='description'>{props.description}</h4>
            )}
            {props.subtitle && <div className='subtitle'>{props.subtitle}</div>}
            {props.closeIcon && !props.isExternal && (
              <span style={{ right: 0 }}>
                <IconClose
                  icon={faTimes}
                  onClick={() => props.onClickClose()}
                  size={'2x'}
                />
              </span>
            )}
          </div>
        </>
      </HeaderDetailedContainer>
    )
  }
)

export default HelpHeaderDetailed
